import React from "react"
import { SvgIcon, SvgIconProps } from "@material-ui/core"

export default function Questionmark(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 36 36">
      <path d="M16.5 27H19.5V24H16.5V27ZM18 3C9.72 3 3 9.72 3 18C3 26.28 9.72 33 18 33C26.28 33 33 26.28 33 18C33 9.72 26.28 3 18 3ZM18 30C11.385 30 6 24.615 6 18C6 11.385 11.385 6 18 6C24.615 6 30 11.385 30 18C30 24.615 24.615 30 18 30ZM18 9C14.685 9 12 11.685 12 15H15C15 13.35 16.35 12 18 12C19.65 12 21 13.35 21 15C21 18 16.5 17.625 16.5 22.5H19.5C19.5 19.125 24 18.75 24 15C24 11.685 21.315 9 18 9Z" />
    </SvgIcon>
  )
}
